<template>
  <!-- Button with icon right -->
  <!-- class="h-10 px-5 text-indigo-700 transition-colors duration-150 ring-1 ring-indigo-500 rounded-lg focus:shadow-outline hover:bg-indigo-500 hover:text-indigo-100" -->
  <button
    type="submit"
    class="inline-flex items-center h-10 px-5 text-white transition-colors duration-150 ring-1 ring-green-light bg-green-light rounded-lg focus:shadow-outline hover:bg-white hover:text-green-light"
    :class="{ 'cursor-wait opacity-75': loading }"
    v-on:click="onClickButton"
    :disabled="loading"
  >
    <slot></slot>
    <!-- Heroicon name: solid/mail -->
    <svg
      v-if="loading"
      xmlns="http://www.w3.org/2000/svg"
      class="h-5 w-5 animate-spin"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "TButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickButton() {
      this.$emit("button");
    },
  },
};
</script>